import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IResult } from '../../types/Users';
import { getIdToken } from '../../auth'; 
import { useAppSelector } from '../store/store';
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState{
    result: IResult []| any,
    resultt: IResult [] | any,
    error: null | any
}

const initialState: IState = {
    result: null,
    resultt: null,
    error: null
}
const token = getIdToken();
export const fetchUserMySelf = createAsyncThunk(
    'fetchUserMySelf',
    async ({token}:{ token: string}) => {
        const data = await fetch(`${BASE_URL_ENDPOINT}/management-ctx/api/v2/user/myself`,{
            method: 'GET',
            headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`},
        } )
            .then( response => response.json())
            .then(data => data)
            .catch(error => {
                console.log("error:",error);
                return error;
            })
        return data
    }
)

export const fetchUser = createAsyncThunk(
    'fetchUser',
    async ({ requestedUserId }: { requestedUserId: string }) => {
        console.log("requestedUserId:", requestedUserId);
        const token2 = getIdToken();
        const data = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/user/${requestedUserId}`,
        {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${token2}`,
          },
          
        })
        .then((response) => response.json())
        .then((data) => data)
        .catch((error) => {
          console.log("error:",error);
          return error;
        });
      console.log("datax:",data);
      return data;
    }
  );
  

const usersSlice = createSlice({
    name: "usersSlice",
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(
            fetchUser.fulfilled, (state, action) => {
                state.result = action.payload;
                console.log("state-result-fetch-user***:", state.result);
             
            }
        );
        builder.addCase(
            fetchUser.rejected, (state, action) => {
                state.error = action.payload;
                console.log("state-error-fetch-user***:", state.error);
            }
        );
        builder.addCase(
            fetchUserMySelf.fulfilled, (state, action) => {
                state.result = action.payload;
                console.log("state-result-fetchUserMySelf-user:", state.result);
            }
        );
        builder.addCase(
            fetchUserMySelf.rejected, (state, action) => {
                state.error = action.payload;
                console.log("state-error-fetchUserMySelf-user:", state.error);
            }
        );
    },
});

export default usersSlice.reducer;